import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Link, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { adminPrefix } from "configs/routePrefix";
import { useSelector, useDispatch } from "react-redux";
import "./styles.scss";
import { logout } from "services/Website/AuthService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LangSwitcher from "components/LangSwitcher";
import SettingsService from "services/Admin/SettingsService";

let _cachedStudioName = null;

const BookingIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			class="lucide lucide-calendar w-5 h-5">
			<path d="M8 2v4"></path>
			<path d="M16 2v4"></path>
			<rect width="18" height="18" x="3" y="4" rx="2"></rect>
			<path d="M3 10h18"></path>
		</svg>
	);
};
const SettingsIcon = () => {
	return (
		<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
			<g
				id="SVGRepo_tracerCarrier"
				strokeLinecap="round"
				strokeLinejoin="round"></g>
			<g id="SVGRepo_iconCarrier">
				{" "}
				<path
					d="M10.255 4.18806C9.84269 5.17755 8.68655 5.62456 7.71327 5.17535C6.10289 4.4321 4.4321 6.10289 5.17535 7.71327C5.62456 8.68655 5.17755 9.84269 4.18806 10.255C2.63693 10.9013 2.63693 13.0987 4.18806 13.745C5.17755 14.1573 5.62456 15.3135 5.17535 16.2867C4.4321 17.8971 6.10289 19.5679 7.71327 18.8246C8.68655 18.3754 9.84269 18.8224 10.255 19.8119C10.9013 21.3631 13.0987 21.3631 13.745 19.8119C14.1573 18.8224 15.3135 18.3754 16.2867 18.8246C17.8971 19.5679 19.5679 17.8971 18.8246 16.2867C18.3754 15.3135 18.8224 14.1573 19.8119 13.745C21.3631 13.0987 21.3631 10.9013 19.8119 10.255C18.8224 9.84269 18.3754 8.68655 18.8246 7.71327C19.5679 6.10289 17.8971 4.4321 16.2867 5.17535C15.3135 5.62456 14.1573 5.17755 13.745 4.18806C13.0987 2.63693 10.9013 2.63693 10.255 4.18806Z"
					stroke="#99a1af"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"></path>{" "}
				<path
					d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
					stroke="#99a1af"
					strokeWidth="2"></path>{" "}
			</g>
		</svg>
	);
};
const AdminsIcon = () => {
	return (
		<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#99a1af">
			<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
			<g
				id="SVGRepo_tracerCarrier"
				strokeLinecap="round"
				strokeLinejoin="round"></g>
			<g id="SVGRepo_iconCarrier">
				{" "}
				<g>
					{" "}
					<path fill="none" d="M0 0h24v24H0z"></path>{" "}
					<path d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm9 6h1v5h-8v-5h1v-1a3 3 0 0 1 6 0v1zm-2 0v-1a1 1 0 0 0-2 0v1h2z"></path>{" "}
				</g>{" "}
			</g>
		</svg>
	);
};
const DevicesIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			class="lucide lucide-monitor w-5 h-5">
			<rect width="20" height="14" x="2" y="3" rx="2"></rect>
			<line x1="8" x2="16" y1="21" y2="21"></line>
			<line x1="12" x2="12" y1="17" y2="21"></line>
		</svg>
	);
};
const GamesIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			class="lucide lucide-gamepad2 lucide-gamepad-2 w-5 h-5">
			<line x1="6" x2="10" y1="11" y2="11"></line>
			<line x1="8" x2="8" y1="9" y2="13"></line>
			<line x1="15" x2="15.01" y1="12" y2="12"></line>
			<line x1="18" x2="18.01" y1="10" y2="10"></line>
			<path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"></path>
		</svg>
	);
};
const CouponsIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			class="lucide lucide-ticket w-5 h-5">
			<path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
			<path d="M13 5v2"></path>
			<path d="M13 17v2"></path>
			<path d="M13 11v2"></path>
		</svg>
	);
};
const PackagesIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round">
			<circle cx="12" cy="12" r="10" />
			<path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
			<path d="M12 6v2m0 8v2" />
		</svg>
	);
};
const UsersIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round">
			<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
			<circle cx="9" cy="7" r="4" />
			<path d="M23 21v-2a4 4 0 0 0-3-3.87" />
			<path d="M16 3.13a4 4 0 0 1 0 7.75" />
		</svg>
	);
};
const WalletIcon = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.2617 15.998H9.26172"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12.66 2.51814L12.63 2.58814L9.72996 9.31814H6.87996C6.19996 9.31814 5.54996 9.45814 4.95996 9.70814L6.70996 5.52814L6.74996 5.42814L6.81996 5.26814C6.83996 5.20814 6.85996 5.14814 6.88996 5.09814C8.19996 2.06814 9.67996 1.37814 12.66 2.51814Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M18.05 9.51856C17.6 9.37856 17.12 9.31855 16.64 9.31855H9.72998L12.63 2.58855L12.66 2.51855C12.81 2.56855 12.95 2.63855 13.1 2.69855L15.31 3.62855C16.54 4.13855 17.4 4.66855 17.92 5.30855C18.02 5.42855 18.1 5.53855 18.17 5.66855C18.26 5.80855 18.33 5.94855 18.37 6.09855C18.41 6.18855 18.44 6.27855 18.46 6.35855C18.73 7.19855 18.57 8.22856 18.05 9.51856Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M21.5217 14.1984V16.1484C21.5217 16.3484 21.5117 16.5484 21.5017 16.7484C21.3117 20.2384 19.3617 21.9984 15.6617 21.9984H7.86172C7.62172 21.9984 7.38172 21.9784 7.15172 21.9484C3.97172 21.7384 2.27172 20.0384 2.06172 16.8584C2.03172 16.6284 2.01172 16.3884 2.01172 16.1484V14.1984C2.01172 12.1884 3.23172 10.4584 4.97172 9.70836C5.57172 9.45836 6.21172 9.31836 6.89172 9.31836H16.6517C17.1417 9.31836 17.6217 9.38836 18.0617 9.51836C20.0517 10.1284 21.5217 11.9884 21.5217 14.1984Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.71 5.52832L4.96 9.70832C3.22 10.4583 2 12.1883 2 14.1983V11.2683C2 8.42832 4.02 6.05832 6.71 5.52832Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M21.5186 11.2677V14.1977C21.5186 11.9977 20.0586 10.1277 18.0586 9.52766C18.5786 8.22766 18.7286 7.20766 18.4786 6.35766C18.4586 6.26766 18.4286 6.17766 18.3886 6.09766C20.2486 7.05766 21.5186 9.02766 21.5186 11.2677Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

const AdminSidebarContent = (props) => {
	const { t } = props;
	const ref = useRef();
	const AuthData = useSelector((state) => state.Auth);
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [show, setShow] = useState(false);
	const [name, setName] = useState(false);
	const close = () => props.closeMobileSidebar?.();
	const isExist = (data) => AuthData?.permissions?.includes(data); //|| AuthData?.email === "admin@meras.com";
	const history = useHistory();
	useEffect(() => {
		(props.location.pathname.split("/")[2] === "payment-plan" ||
			props.location.pathname.split("/")[2] === "interactive") &&
			setShow(true);
	}, [props.location.pathname]);

	useEffect(() => {
		if (_cachedStudioName) {
			setName(_cachedStudioName);
			return;
		}
		setLoading(true);
		new SettingsService()
			.getList()
			.then((res) => {
				const response = res?.data?.data;
				const studio = (res?.status && response?.studio_name)
					? response.studio_name
					: "VR Premium Studio";
				_cachedStudioName = studio;
				setName(studio);
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	useEffect(() => {
		const pathName = props.location.pathname;
		const initMenu = () => {
			new MetisMenu("#side-menu");
			let matchingMenuItem = null;
			const ul = document.getElementById("side-menu");
			const items = ul.getElementsByTagName("a");
			for (let i = 0; i < items.length; ++i) {
				if (pathName.split("/")[2] === "setting") {
					if (pathName?.split("/")[3] === items[i].pathname?.split("/")[3]) {
						matchingMenuItem = items[i];
						break;
					}
				} else if (
					pathName?.split("/")[2] === items[i].pathname?.split("/")[2]
				) {
					matchingMenuItem = items[i];
					break;
				} else if (pathName === items[i].pathname) {
					matchingMenuItem = items[i];
					break;
				}
			}
			if (matchingMenuItem) {
				activateParentDropdown(matchingMenuItem);
			}
		};
		initMenu();
	}, [props.location.pathname]);

	useEffect(() => {
		ref.current.recalculate();
	});

	function scrollElement(item) {
		if (item) {
			const currentPosition = item.offsetTop;
			if (currentPosition > window.innerHeight) {
				ref.current.getScrollElement().scrollTop = currentPosition - 300;
			}
		}
	}

	function activateParentDropdown(item) {
		item.classList.add("active");
		const parent = item.parentElement;
		const parent2El = parent.childNodes[1];
		if (parent2El && parent2El.id !== "side-menu") {
			parent2El.classList.add("mm-show");
		}

		if (parent) {
			parent.classList.add("mm-active");
			const parent2 = parent.parentElement;
			if (parent2) {
				parent2.classList.add("mm-show"); // ul tag
				const parent3 = parent2.parentElement; // li tag
				if (parent3) {
					parent3.classList.add("mm-active"); // li
					parent3.childNodes[0].classList.add("mm-active"); //a
					const parent4 = parent3.parentElement; // ul
					if (parent4) {
						parent4.classList.add("mm-show"); // ul
						const parent5 = parent4.parentElement;
						if (parent5) {
							parent5.classList.add("mm-show"); // li
							parent5.childNodes[0].classList.add("mm-active"); // a tag
						}
					}
				}
			}
			scrollElement(item);
			return false;
		}
		scrollElement(item);
		return false;
	}

	return (
		<React.Fragment>
			<SimpleBar style={{ maxHeight: "100%", height: "100%" }} ref={ref}>
				<div id="sidebar-menu">
					<div className="panel">
						<div className="dash-icon">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="#000"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								className="lucide lucide-layout-dashboard w-5 h-5 text-[#0B0F14]">
								<rect width="7" height="9" x="3" y="3" rx="1"></rect>
								<rect width="7" height="5" x="14" y="3" rx="1"></rect>
								<rect width="7" height="9" x="14" y="12" rx="1"></rect>
								<rect width="7" height="5" x="3" y="16" rx="1"></rect>
							</svg>
						</div>
						<div>
							<p className="title mb-0">{t("Admin Panel")}</p>
							<p className="description mb-0">{name}</p>
						</div>
					</div>
					<ul className="metismenu p-3 list-unstyled" id="side-menu">
						<li>
							<Link to={`${adminPrefix}/bookings`} onClick={close}>
								<BookingIcon />
								<span>{t("Bookings")}</span>
							</Link>
						</li>
						<li>
							<Link to={`${adminPrefix}/admins`} onClick={close}>
								<AdminsIcon />
								<span>{t("Manage Admins")}</span>
							</Link>
						</li>
						<li>
							<Link to={`${adminPrefix}/devices`} onClick={close}>
								<DevicesIcon />
								<span>{t("Devices")}</span>
							</Link>
						</li>
						<li>
							<Link to={`${adminPrefix}/games`} onClick={close}>
								<GamesIcon />
								<span>{t("Games")}</span>
							</Link>
						</li>
						<li>
							<Link to={`${adminPrefix}/coupons`} onClick={close}>
								<CouponsIcon />
								<span>{t("Coupons")}</span>
							</Link>
						</li>
						<li>
							<Link to={`${adminPrefix}/pricings`} onClick={close}>
								<WalletIcon />
								<span>{t("Pricings")}</span>
							</Link>
						</li>
						<li>
							<Link to={`${adminPrefix}/packages`} onClick={close}>
								<PackagesIcon />
								<span>{t("Packages")}</span>
							</Link>
						</li>
						<li>
							<Link to={`${adminPrefix}/users`} onClick={close}>
								<UsersIcon />
								<span>{t("Users")}</span>
							</Link>
						</li>
						<li>
							<Link to={`${adminPrefix}/settings`} onClick={close}>
								<SettingsIcon />
								<span>{t("Settings")}</span>
							</Link>
						</li>
					</ul>
				</div>
				<div className="bottom-sidebar">
					<LangSwitcher />
					<button
						onClick={() => {
							logout();
							history.push("/admin/login");
						}}>
						<i className="fa fa-angle-left" />
						{t("Exit")}
					</button>
				</div>
			</SimpleBar>
		</React.Fragment>
	);
};

AdminSidebarContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
};

export default withRouter(withTranslation()(AdminSidebarContent));
